import React from 'react';
import { JobDetailResponse, JobResponse } from '@doda/api-client/aspida/@types';
import { DODA_SITE_DOMAIN } from '@doda/common/src/constants/urls';
import { createBreadCrumbListLd } from '@doda/common/src/logics/createBreadCrumbListLd';
import type { Tab } from '../../types/tab';
import { useTab } from '../TabArea/hooks/useTab';

/**
 * ぱんくずリスト構造化データコンポーネント
 * @param {JobDetailResponse} job 求人詳細APIレスポンス値
 * @param {boolean} isScout スカウト求人の有無
 * @param {Tab} initialTab タブの初期状態
 * @param {jid} string 求人ID
 * @param {JobResponse['wcnsId']} wcncId 原稿種別
 */
export interface Props {
  job: JobDetailResponse;
  isScout: boolean;
  initialTab: Tab;
  jid: string;
  wcnsId: JobResponse['wcnsId'];
}

export const BreadCrumbListLd: React.FC<Props> = React.memo(
  ({ job, isScout, initialTab, jid, wcnsId }) => {
    const { currentTabName } = useTab({
      initialTab,
      jid,
      wcnsId: wcnsId || '',
    });

    const domain =
      DODA_SITE_DOMAIN[process.env.APP_ENV as keyof typeof DODA_SITE_DOMAIN] ||
      DODA_SITE_DOMAIN.Production;
    let jsonData;

    /**
     * 以下の条件の場合、構造化データを表示させる。
     * googleForJobs求人でない場合
     * スカウト求人でない場合
     * 求人詳細タブの場合
     */
    if (
      job?.job?.googleForJobs?.canPublish &&
      !isScout &&
      currentTabName === 'jd'
    ) {
      jsonData = createBreadCrumbListLd(job, domain, 'の求人・中途採用情報');
    }

    return (
      <>
        {jsonData ? (
          <script
            type="application/ld+json"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(jsonData),
            }}
          />
        ) : null}
      </>
    );
  }
);

BreadCrumbListLd.displayName = 'BreadCrumbListLd';
